import { GET_REPORT, SET_REPORT } from "./types";

const INITIAL_STATE = {
    requesting: false,
    report: false,
    posting: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_REPORT.REQUEST: {
            return { ...state, requesting: true };
        }
        case GET_REPORT.FAIL: {
            return { ...state, requesting: false };
        }
        case GET_REPORT.SUCCESS: {
            return { ...state, requesting: false, report: action.payload };
        }
        case SET_REPORT.REQUEST: {
            return { ...state, requesting: true, posting: true };
        }
        case SET_REPORT.FAIL: {
            return { ...state, requesting: false, posting: false };
        }
        case SET_REPORT.SUCCESS: {
            return { ...state, requesting: false, posting: false };
        }
        default: {
            return state;
        }
    }
};
